export default __webpack_public_path__ + "static/media/videoPlayer.1e282b59.png";